import {makeAutoObservable} from "mobx"
import {AdminStore} from "store/admin/admin.store"

export class PathTrackingStore {
    adminStore: AdminStore
    page: number = 0
    size: number = 10
    keyword?: string| undefined = ""
    showOnlyEmergency : boolean = false

    constructor(adminStore: AdminStore) {
        this.adminStore = adminStore
        makeAutoObservable(this)
    }

    setPage = (page: number) => {
        this.page = page
    }

    setKeyword = (keyword: string | undefined) => {
        console.log("여기도 되남?")
        this.keyword = keyword
    }

    setShowOnlyEmergency = (showOnlyEmergencyPath: boolean) => {
        this.showOnlyEmergency = showOnlyEmergencyPath
    }
}